var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAmministrazione(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14C4 11.2386 6.23858 9 9 9H39C41.7614 9 44 11.2386 44 14V34C44 36.7614 41.7614 39 39 39H9C6.23858 39 4 36.7614 4 34V14ZM26.5 17.75C26.5 18.4404 27.0596 19 27.75 19H37.75C38.4404 19 39 18.4404 39 17.75C39 17.0596 38.4404 16.5 37.75 16.5H27.75C27.0596 16.5 26.5 17.0596 26.5 17.75ZM26.5 24C26.5 24.6904 27.0596 25.25 27.75 25.25H37.75C38.4404 25.25 39 24.6904 39 24C39 23.3096 38.4404 22.75 37.75 22.75H27.75C27.0596 22.75 26.5 23.3096 26.5 24ZM29 30.25C29 30.9404 29.5596 31.5 30.25 31.5H37.75C38.4404 31.5 39 30.9404 39 30.25C39 29.5596 38.4404 29 37.75 29H30.25C29.5596 29 29 29.5596 29 30.25ZM26.5 35.25C26.5 30.4175 22.0228 26.5 16.5 26.5C11.2842 26.5 7.00105 29.994 6.54089 34.453C6.75401 35.6174 7.77392 36.5 8.99996 36.5H26.3987C26.4654 36.0917 26.5 35.6744 26.5 35.25ZM21.5 19C21.5 16.2386 19.2614 14 16.5 14C13.7385 14 11.5 16.2386 11.5 19C11.5 21.7614 13.7385 24 16.5 24C19.2614 24 21.5 21.7614 21.5 19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAmministrazione);
export default __webpack_public_path__ + "static/media/ico-amministrazione.5c1e42357838e1eae9f80accdebf979f.svg";
export { ForwardRef as ReactComponent };